import { PageHero, CTASection } from "@/components/site/Sections";
import CostCalculator from "@/components/site/CostCalculator";

export default function Calculator() {
  return (
    <div data-testid="calculator-page">
      <PageHero
        eyebrow="Cost calculator"
        title="Know your build cost in seconds."
        subtitle="Enter your plot size and choose a package to get an instant, transparent estimate for your construction project in Lucknow."
        image="https://images.unsplash.com/photo-1761479135364-4240520b5793?crop=entropy&cs=srgb&fm=jpg&q=85"
      />
      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-20 lg:py-28">
        <CostCalculator />
      </section>
      <CTASection />
    </div>
  );
}
